import { render, staticRenderFns } from "./BenchTurnover.vue?vue&type=template&id=11586714&scoped=true&"
import script from "./BenchTurnover.vue?vue&type=script&lang=js&"
export * from "./BenchTurnover.vue?vue&type=script&lang=js&"
import style0 from "./BenchTurnover.vue?vue&type=style&index=0&id=11586714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11586714",
  null
  
)

export default component.exports